import { WizardOperation } from "@coworker/apprestructured/src/shared/hooks/wizard/useWizardOperations/types";
import { CloseTaskPayload } from "./api/useCloseTask";
import { MoveUsersToTeamPayload } from "./api/useMoveUsersToTeam";
import { ResignTasksPayload } from "./api/useReassignTasks";

export enum TEAM_DELETION_FLOW_OPERATIONS {
  MOVE_USERS_TO_TEAM = "MOVE_USERS_TO_TEAM",
  REASSIGN_TASKS = "REASSIGN_TASKS",
  CLOSE_TASKS = "CLOSE_TASKS",
}

type MoveUsersToTeamOperation =
  WizardOperation<TEAM_DELETION_FLOW_OPERATIONS.MOVE_USERS_TO_TEAM> & {
    payload: MoveUsersToTeamPayload;
  };
type CloseTaskOperation =
  WizardOperation<TEAM_DELETION_FLOW_OPERATIONS.CLOSE_TASKS> & {
    payload: CloseTaskPayload;
  };
type ReassignTasksOperation =
  WizardOperation<TEAM_DELETION_FLOW_OPERATIONS.REASSIGN_TASKS> & {
    payload: ResignTasksPayload;
  };
export type TeamDeletionOperation =
  CloseTaskOperation | ReassignTasksOperation | MoveUsersToTeamOperation;

export const isMoveUsersToTeamOperation = (
  operation: TeamDeletionOperation
): operation is MoveUsersToTeamOperation =>
  operation.type === TEAM_DELETION_FLOW_OPERATIONS.MOVE_USERS_TO_TEAM;

export const isCloseTaskOperation = (
  operation: TeamDeletionOperation
): operation is CloseTaskOperation =>
  operation.type === TEAM_DELETION_FLOW_OPERATIONS.CLOSE_TASKS;

export const isReassignTasksOperation = (
  operation: TeamDeletionOperation
): operation is ReassignTasksOperation =>
  operation.type === TEAM_DELETION_FLOW_OPERATIONS.REASSIGN_TASKS;
